import { ICharacter, useTranslation } from "@next-platform/client-common-core";
import appLogger from "@next-platform/client-common-core/logger/appLogger";
import { Modal } from "@next-platform/client-common-spicy-ui";
import { Image, Spacer, Spinner } from "@nextui-org/react";

import { Row, SpicyButton, Text } from "@/components/customComponents";
import Trans from "@/components/Trans/Trans";
import useApi from "@/components/useApi";

const logger = appLogger.withTag("ModalTraining");

type ModalTrainingProps = {
  isOpen: boolean;
  character: ICharacter;
  onClose: (open: boolean) => void;
};

export default function ModalTraining({ onClose, isOpen, character }: ModalTrainingProps) {
  const { t } = useTranslation();
  const { jsonApiService, callApi, data, isLoading, errorData } = useApi<{ count: number }>();

  const onTrainingPress = () => {
    callApi(jsonApiService.createResource, "characters/train", {
      character_id: character.id,
    }).then((response) => {
      logger.info(response);
    });
  };

  const Content = () => {
    if (errorData.message) {
      return (
        <>
          <Trans i18nKey="chat:modal.imageTraining.error.submitFailed" />
          <br />
          <br />
          <Text type={"error"}>{errorData.message}</Text>
          <br />
        </>
      );
    }
    if (data) {
      return (
        <>
          <Text>
            <Trans i18nKey="chat:modal.imageTraining.success.submitted" />
          </Text>
          <Spacer y={1} />
          <Text>
            <Trans i18nKey="chat:modal.imageTraining.success.queueInfo" values={{ count: data?.count }} />
          </Text>
          <Spacer y={1} />
        </>
      );
    }
    if (isLoading) {
      return (
        <>
          <Text>
            <Trans i18nKey="chat:modal.imageTraining.loading" />
          </Text>
          <Spinner />
          <Spacer y={1} />
        </>
      );
    }

    if (character?.lora_status === "pending") {
      return (
        <div className="flex items-center flex-col">
          <Trans i18nKey="chat:modal.imageTraining.pending.inQueue" />
          <br />
          <br />
          <Trans i18nKey="chat:modal.imageTraining.pending.checkBack" />
          <Image className="" src="/Assets/Training.gif" width={150} height={150} />
        </div>
      );
    }

    return (
      <>
        <Text>
          <Trans i18nKey="chat:modal.imageTraining.description" />
        </Text>
        <Spacer y={3} />
        <Row justify="center">
          <SpicyButton variant="secondary" color="primary_strong" onPress={onTrainingPress}>
            <Trans i18nKey="chat:modal.imageTraining.cta.train" values={{ characterName: character?.name }} />
          </SpicyButton>
        </Row>
        <Spacer y={5} />
        <p>
          <Trans i18nKey="chat:modal.imageTraining.requestLimit" components={{ b: <b /> }} />
        </p>

        <Spacer y={5} />
      </>
    );
  };

  return (
    <Modal
      title={t("chat:modal.imageTraining.title")}
      classNames={{ title: "text-center pl-[28px]" }}
      open={isOpen}
      onOpenChange={onClose}
      className="text-center"
    >
      <Content />
      <Text variant={"xs"}>
        <Trans i18nKey="chat:modal.imageTraining.footer.processingTime" />
      </Text>
    </Modal>
  );
}
